import { isGuest } from '@/tool/profile';

import { SET_GUEST_NOTICE_VISIBLE } from '../constants/GuestConstants';

const initialState = {
  guestNoticeVisible: isGuest(),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_GUEST_NOTICE_VISIBLE:
      return {
        ...state,

        guestNoticeVisible: action.payload,
      };
    default: {
      return state;
    }
  }
}
